<template>
  <div class="public-content order">
    <div class="breadcrumb">SKU组关联平台</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-input v-model="formInline.order" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-input v-model="formInline.order" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-input v-model="formInline.username" placeholder="请输入用户名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台类型:">
              <el-select v-model="formInline.payStatus" placeholder="请选择" clearable>
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker clearable v-model="value2" type="daterange" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit" round>查询</el-button>
            <el-button class="search-ok" @click="cancelRelate" round>取消关联</el-button>
            <el-button class="search-ok" @click="addPlateform" round type="primary">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="platformNum" label="平台号" min-width="10px">
          </el-table-column>
          <el-table-column prop="username" label="平台名称" min-width="10px">
          </el-table-column>
          <el-table-column prop="platformNum" label="平台类型" min-width="10">
          </el-table-column>
          <el-table-column prop="platformName" label="业务" min-width="10">
          </el-table-column>
          <el-table-column prop="payDate" label="创建日期" min-width="10">
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination"></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
export default {
  name: 'order',
  components: {
    VPagination, CombinedDialog
  },
  data () {
    return {
      formInline: {
        order: '',
        user: '',
        platform: '',
        business: '',
        platformName: '',
        orderType: '',
        payStatus: '',
        orderStatus: '',
        createTime: ''
      },
      tableData: [{
        orderNumber: '29828239888',
        username: '',
        platformNum: 'v29828239888',
        platformName: '123',
        plateformType: '',
        salesman: 'zhangsan',
        orderType: '',
        createDate: '',
        payDate: '',
        plateformPrice: '',
        payWay: '',
        orderStatus: '审核'
      }, {
        orderNumber: '29828239888',
        username: '',
        platformNum: '',
        platformName: '123',
        plateformType: '',
        salesman: 'zhangsan',
        orderType: '',
        createDate: '',
        payDate: '',
        plateformPrice: '',
        payWay: '',
        orderStatus: '查看/编辑'
      }],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }]
    }
  },
  methods: {
    onSubmit () {
      // 向后台发送post请求,获取查询数据存储在tableData
      //
      this.$axios.post().then((res) => {
      })
    },
    getPlatformStatus (status) {
      if (status === '审核') {
        this.$router.push('./checkplatform')
      }
      if (status === '查看/编辑') {
        this.$router.push('./editplatform')
      }
    },
    cancelRelate () {
      this.$refs.dialogRef.show('checktrue', '确定提示')
    },
    addPlateform () {
      this.$router.push('./addconnect')
    },
    handleSelectionChange () { }
  }
}
</script>
 <style scoped lang="less">
 @import "index";
 @deep: ~">>>";
 </style>
